import React from 'react';

interface SyfoAdviserIconProps {
  className?: string;
  size?: number;
}

/**
 * Syfo application icon component
 * Displays the custom SVG icon for the Syfo brand
 */
export const SyfoAdviserIcon: React.FC<SyfoAdviserIconProps> = ({ 
  className = "", 
  size 
}) => {
  const sizeProps = size ? { width: size, height: size } : {};
  
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          id="syfo-icon-gradient-88"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ba4dea" stopOpacity="1" />
          <stop offset="1" stopColor="#7f64fa" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          id="syfo-icon-gradient-2"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#9f16d7" stopOpacity="1" />
          <stop offset="1" stopColor="#594bef" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          xlinkHref="#syfo-icon-gradient-88"
          id="syfo-icon-gradient-91"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.77271274,0,0,0.77271274,27.22206,2.186097)"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
        />
        <linearGradient
          xlinkHref="#syfo-icon-gradient-2"
          id="syfo-icon-gradient-92"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.77276567,0,0,0.30148601,32.208528,44.819478)"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
        />
        <linearGradient
          xlinkHref="#syfo-icon-gradient-2"
          id="syfo-icon-gradient-93"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.77276567,0,0,0.30148601,32.208528,186.317)"
          x1="64"
          y1="256"
          x2="448"
          y2="256"
        />
      </defs>
      
      <g transform="translate(-14.990183,-11.731948)">
        <path
          fill="#663adc"
          fillOpacity="1"
          d="m 438.57812,120.68164 v 194.71094 c 0,31.1073 -29.14468,56.15039 -65.3457,56.15039 H 215.40625 l -34.84375,32.81836 c 8.78576,8.09699 20.52186,13.04101 33.47461,13.04101 h 134.90625 l 97.56641,84.42188 1.34179,-84.42188 c 25.80128,-0.353 49.45313,-22.05587 49.45313,-49.45312 V 170.13477 c 0,-27.39726 -22.05588,-49.45313 -49.45313,-49.45313 z"
        />
        <path
          fill="url(#syfo-icon-gradient-91)"
          d="m 94.12929,33.639675 h 271.81446 c 27.39731,0 49.45362,22.056312 49.45362,49.453615 v 215.81446 c 0,27.3973 -22.05631,49.45362 -49.45362,49.45362 H 207.03652 L 95.47064,451.06511 94.12929,348.36137 C 69.40248,347.45778 44.675675,331.55268 44.675675,298.90775 V 83.09329 c 0,-27.397303 22.056313,-49.453615 49.453615,-49.453615 z"
        />
        <rect
          fill="url(#syfo-icon-gradient-92)"
          width="296.742"
          height="115.77063"
          x="81.66552"
          y="64.114616"
          rx="37.7244"
          ry="38.59021"
        />
        <rect
          fill="url(#syfo-icon-gradient-93)"
          width="296.742"
          height="115.77063"
          x="81.66552"
          y="205.61205"
          rx="37.7244"
          ry="38.59021"
        />
        <path
          fill="#ffffff"
          d="m 183.02038,103.71762 v 28.13868 a 8.4271757,8.4271757 0 0 0 8.42594,8.42594 h 77.18042 a 8.4271757,8.4271757 0 0 0 8.42593,-8.42594 v -28.13868 h -16.85186 v 19.71284 h -60.32856 v -19.71284 z"
        />
        <path
          fill="#ffffff"
          d="m 183.02038,245.21505 v 28.1387 a 8.4271757,8.4271757 0 0 0 8.42593,8.42592 h 77.18043 a 8.4271757,8.4271757 0 0 0 8.42592,-8.42592 v -28.1387 H 260.2008 v 19.71285 h -60.32856 v -19.71285 z"
        />
      </g>
    </svg>
  );
};

export default SyfoAdviserIcon;
